import { UserProvider } from "./UserContext";
import { LoginPopupProvider } from "./components/LoginPopup/LoginPopupContext";
import { BrowserRouter } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { GlobalProvider } from "./GlobalProvider";
import SHREEJI9 from "./chats/SHREEJI9";
import A7EXCH from "./chats/A7EXCH";
import config from "./config";
import AppRouter from "./pages/AppRouter";
import DTOD from "./chats/DTOD";
import BETLIVE from "./chats/BETLIVE";
import DICE11X from "./chats/DICE11X";
import { useNavigate } from "react-router-dom";
import useDetectDevTools from "./useDetectDevTools";
import devtools from 'devtools-detect';
import { useDevToolsStatus } from "./useDevToolsStatus";

function App() {
  const [loading, setLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  // const navigate = useNavigate();

  const initialized = useRef(false);

//   useEffect(() => {
//   document.addEventListener("contextmenu", e => e.preventDefault());

//   document.addEventListener("keydown", e => {
//     if (
//       e.key === "F12" ||
//       (e.ctrlKey && e.shiftKey && ["I", "J", "C"].includes(e.key)) ||
//       (e.ctrlKey && e.key === "U")
//     ) {
//       e.preventDefault();
//     }
//   });
// }, []);

  //  const devToolsOpen = useDetectDevTools();
  //  const isDevToolsOpen = useDevToolsStatus();
  //    useEffect(() => {
  //      console.error(isDevToolsOpen,"isDevToolsOpenisDevToolsOpen");
  //   if (isDevToolsOpen) {
  //     setIsError(true);
  //   }
  // }, [isDevToolsOpen]);



  const settheme = (parsedData) => {
    const faviconUrl = `https://admin.${window.location.hostname}/logo/${window.location.hostname}.ico`;
    const faviconElement = document.getElementById("dynamic-favicon");
    if (faviconElement) {
      faviconElement.href = faviconUrl;
    } else {
      console.warn("Favicon element not found.");
    }

    const root = document.documentElement;
    const colorCodes = parsedData.colorCode;
    localStorage.setItem("logoData", JSON.stringify(parsedData.logoSizeData));
    localStorage.setItem("isB2c", JSON.stringify(parsedData.isB2c));
    localStorage.setItem(
      "basicDetails",
      JSON.stringify(parsedData.basicDetails)
    );
    localStorage.setItem(
      "socialLinkObject",
      JSON.stringify(parsedData.socialLinkObject)
    );
    localStorage.setItem("pubanner", JSON.stringify(parsedData.pubanner));
    config.pubObj = parsedData.pubanner;
    // localStorage.setItem("isB2c", true);
    localStorage.setItem("adminurl", parsedData.adminurl);
    config.AdminUrl = parsedData.adminurl ? parsedData.adminurl : "";
    // Update CSS variables
    document.title = parsedData.basicDetails.mainName;
    localStorage.setItem("mainName", parsedData.basicDetails.mainName);
    root.style.setProperty("--primary-color", colorCodes.color2);
    root.style.setProperty("--primary-light", colorCodes.color7);
    root.style.setProperty("--light-color", colorCodes.color5);

    if (colorCodes.sidemenu_bg) {
      root.style.setProperty("--sidemenu-bg", colorCodes.sidemenu_bg);
    }
    if (colorCodes.sidemenu_text) {
      root.style.setProperty("--sidemenu-text", colorCodes.sidemenu_text);
    }
    if (colorCodes.sidemenu_text_hover) {
      root.style.setProperty(
        "--sidemenu-text-hover",
        colorCodes.sidemenu_text_hover
      );
    }
    if (colorCodes.notification_text) {
      root.style.setProperty(
        "--notification-text",
        colorCodes.notification_text
      );
    }
    if (colorCodes.betslip_element) {
      root.style.setProperty("--betslip-elements", colorCodes.betslip_element);
    }
    root.style.setProperty(
      "--header-bg",
      `linear-gradient(135deg, ${colorCodes.header_bg1} 0%, ${colorCodes.header_bg2} 100%)`
    );
    root.style.setProperty(
      "--primary-gradient-hover",
      `linear-gradient(135deg, ${colorCodes.color6_1} 0%, ${colorCodes.color6_2} 100%)`
    );
    root.style.setProperty(
      "--primary-gradient",
      `linear-gradient(135deg, ${colorCodes.color1_1} 0%, ${colorCodes.color1_2} 100%)`
    );
    localStorage.setItem("logoDetails", JSON.stringify(parsedData.logoDetail));
    config.logoDetails = parsedData.logoDetail;
    const faviconUrl1 = parsedData.logoDetail.fevicon;
    const faviconElement1 = document.getElementById("dynamic-favicon");
    if (faviconElement1) {
      faviconElement1.href = faviconUrl1;
    } else {
      console.warn("Favicon element not found.");
    }
  };

  useEffect(() => {
    const fetchColorCodes = async () => {
      try {
        const hostname = window.location.hostname;
        if (!initialized.current) {
          initialized.current = true;
        }
        // Update Favicon
        const faviconUrl = `https://admin.${hostname}/logo/${hostname}.ico`;
        const faviconElement = document.getElementById("dynamic-favicon");
        if (faviconElement) {
          faviconElement.href = faviconUrl;
        } else {
          console.warn("Favicon element not found.");
        }

        /////// new api ///////
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/colorCode2?whiteLabel=${hostname}`
        );

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const parsedData = await response.json();
        localStorage.setItem("colorCode", JSON.stringify(parsedData));
        settheme(parsedData);
      } catch (error) {
        setIsError(true);
        setErrorMessage(error.message); // <-- store error
      } finally {
        setLoading(false);
      }
    };
    if (localStorage.getItem("colorCode")) {
      let parsedData = JSON.parse(localStorage.getItem("colorCode"));
      settheme(parsedData);
      setLoading(false);
      setIsError(false);
    } else {
      fetchColorCodes();
    }
  }, []);

  const checkScript = () => {
    if (window.location.hostname == "a7sport.com") {
      return <A7EXCH />;
    } else if (window.location.hostname == "shreeji9.com") {
      return <SHREEJI9 />;
    } else if (window.location.hostname == "dtod.net") {
      return <DTOD />;
    } else if (window.location.hostname == "betlive247.net") {
      return <BETLIVE />;
    } else if (window.location.hostname == "dice11x.com") {
      return <DICE11X />;
    } else {
      return "";
    }
  };

  return (
    <div className="App min-height100">
      {loading && (
        <div id="loader" className="loader-page">
          <span className="loader"></span>
        </div>
      )}
      {isError && (
        <div className="error-page">
          <div className="error-container">
            <img src={require(`./assets/images/Network Error.png`)} alt="" />
            <h2>Connection Error...</h2>
            <span>Error code: 7883 - Please try again in different tab!</span>
            <p style={{ display: "none" }}>{errorMessage}</p>
          </div>
        </div>
      )}
      {!loading && !isError && (
        <UserProvider>
          <GlobalProvider>
            <LoginPopupProvider>
              <BrowserRouter>
                <AppRouter checkScript={checkScript} />
              </BrowserRouter>
            </LoginPopupProvider>
          </GlobalProvider>
        </UserProvider>
      )}
    </div>
  );
}

export default App;
